import { Avatar, Button, ModalComponentsPropsOverrides, Typography } from "@mui/material";
import ModalComponent, { ItemNba } from "./Modal";
import { useEffect, useState } from "react";
import { IProfile, useAuthentication } from "../../../../store/Authentication";


interface SelectTeamComponentProps {
  }
  const SelectTeamComponent: React.FC<SelectTeamComponentProps> = () => {
    const { profile } = useAuthentication();
      
    const[selected, setSelected] = useState<ItemNba | null>(null);
    const [open, setOpen] = useState(false);
    const [quantityChanges, setQuantityChanges] = useState<number>(0);
    function handleSelected(item: ItemNba){
        setQuantityChanges(quantityChanges+1)
        setSelected(item)
    }
    const alteracoesRestantes = (profile.nbaAlteracoesMaximas??0) - quantityChanges;
    const fraseAlteracoes = alteracoesRestantes === 1 ? "alteração restante" : "alterações restantes";
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    useEffect(() => {
        if(profile.nbaAlteracoes !== undefined){
            setQuantityChanges(profile.nbaAlteracoes);
        }
      }, [profile]);

    return (
        <>
        {(quantityChanges ?? profile.nbaAlteracoes) >= (profile.nbaAlteracoesMaximas ?? 2) ?
        <>
            <Typography variant="body1" mt={4}>
                Seu time selecionado para esta temporado é o:
            </Typography>
            <div style={{display: "flex", gap: '8px', justifyContent: "start", alignItems: "center", width: '100%', marginTop: "8px"}}>
                <Avatar src={`./content/images/NbaTeamChoice-opcionais/NbaTeamChoice_${profile.timeNba || selected?.idNbaEquipe}.jpg`} sx={{width:56, height: 56}}></Avatar>
                <Typography gutterBottom variant="h6" display={"flex"} gap={'8px'} component="div">
                    {profile.timeNbaNome || selected?.nomeEquipe }
                </Typography>
            </div>
        </>
         :
        <>
            <Typography variant="body1" mt={4}>
                <strong>Escolha seu time da temporada. {(profile.nbaAlteracoes!!! || quantityChanges) >= 1 ? `Atenção, você tem apenas ${alteracoesRestantes} ${fraseAlteracoes}.`: '' }</strong> 
            </Typography>
            <Button variant="text" color="primary"  onClick={handleOpen} style={{width: '100%', textTransform: "none",  border: "1px solid #17408b33", borderRadius: "8px"}}>
                <div style={{display: "flex", gap: '8px', justifyContent: "start", alignItems: "center", width: '100%'}}>
                    <Avatar src={profile.timeNba || selected?.idNbaEquipe ? `./content/images/NbaTeamChoice-opcionais/NbaTeamChoice_${profile.timeNba || selected?.idNbaEquipe}.jpg`: '' } sx={{width:56, height: 56}}></Avatar>
                    <Typography color={"#17408B"} >{profile.timeNba || selected?.idNbaEquipe ? profile.timeNbaNome || selected?.nomeEquipe : 'Nenhum time selecionado'}</Typography>
                </div>
            </Button>
        </>
        }

            <ModalComponent open={open} onClose={handleClose} onSelect={handleSelected} />

            
        </>
    )
}

export default SelectTeamComponent;